
import { NoseurObject } from "@rivtn/noseur";
import { SanitizedResponse } from "../BaseService";
import { HeraBaseService, ISupportPlatform } from "./HeraBaseService";

export interface ISupportContactAddress {
    email: string;
    phone: string;
}

export interface ISupportContactOpeningHour {
    open: string;
    close: string;
}

export interface ISupportContact {
    language: string;
    platform_id: string;
    external_id: string;
    description: string;
    physical_address: string;
    platform: ISupportPlatform;
    addresses: ISupportContactAddress[];
    holiday_opening_hours: ISupportContactOpeningHour;
    weekdays_opening_hours: ISupportContactOpeningHour;
    weekends_opening_hours: ISupportContactOpeningHour;
}

export class SupportContactService extends HeraBaseService {

    protected static instance: SupportContactService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportContactService.instance) SupportContactService.instance = new SupportContactService();
        return SupportContactService.instance;
    }

    querySupportContacts(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<ISupportContact>> {
        params["platform.platform_id"] = params.platform_id;
        delete params.platform_id;
        return this.report(this.transport.get("/hera/api/v1/support/contact", { query: this.normalizeParams(params) }));
    }

    createSupportContact(supportContact: Partial<ISupportContact>): Promise<SanitizedResponse<ISupportContact>> {
        return this.report(this.transport.post("/hera/api/v1/support/contact", supportContact));
    }

    updateSupportContact(supportContact: Partial<ISupportContact>): Promise<SanitizedResponse<ISupportContact>> {
        return this.report(this.transport.patch(`/hera/api/v1/support/contact/${supportContact.external_id}`, supportContact));
    }

    deleteSupportContact(id: string): Promise<SanitizedResponse<ISupportContact>> {
        return this.report(this.transport.delete(`/hera/api/v1/support/contact/${id}`));
    }

}

